export default __webpack_public_path__ + "static/media/bigLogo.cd66b8f6.png";